import { createAsyncThunk } from "@reduxjs/toolkit";
import { usersAPI } from "../api/usersApi";

export const getUserById = createAsyncThunk(
  "getUserById",
  async (id: number, { rejectWithValue }) => {
    try {
      const { data } = await usersAPI.getUserById(id);
      return data;
    } catch (error) {
      return rejectWithValue("Error");
    }
  }
);
